/**
 * @generated SignedSource<<0083fe69bcaaab588d5ebd3e3265c6df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type rulesPage_DeltaQuery$variables = {
  accountIds?: ReadonlyArray<string> | null | undefined;
  caseSensitive?: boolean | null | undefined;
  delete?: boolean | null | undefined;
  direction?: string | null | undefined;
  endDate?: any | null | undefined;
  matchKind?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  regex?: string | null | undefined;
  ruleId: string;
  startDate?: any | null | undefined;
};
export type rulesPage_DeltaQuery$data = {
  readonly ruleDeltaPreview: {
    readonly captured: ReadonlyArray<{
      readonly accountNumber: string | null | undefined;
      readonly amount: number;
      readonly description: string;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly postingDate: string;
      readonly txn: {
        readonly id: string;
      };
    }>;
    readonly capturedCount: number;
    readonly droppedCount: number;
    readonly droppedManual: ReadonlyArray<{
      readonly accountNumber: string | null | undefined;
      readonly amount: number;
      readonly description: string;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly postingDate: string;
      readonly txn: {
        readonly id: string;
      };
    }>;
    readonly droppedRuleAssigned: ReadonlyArray<{
      readonly accountNumber: string | null | undefined;
      readonly amount: number;
      readonly description: string;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly postingDate: string;
      readonly txn: {
        readonly id: string;
      };
    }>;
    readonly manualConflictCount: number;
    readonly truncated: boolean;
  };
};
export type rulesPage_DeltaQuery = {
  response: rulesPage_DeltaQuery$data;
  variables: rulesPage_DeltaQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "caseSensitive"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "delete"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "direction"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "matchKind"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regex"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v10 = [
  {
    "kind": "Variable",
    "name": "accountIds",
    "variableName": "accountIds"
  },
  {
    "kind": "Variable",
    "name": "caseSensitive",
    "variableName": "caseSensitive"
  },
  {
    "kind": "Variable",
    "name": "delete",
    "variableName": "delete"
  },
  {
    "kind": "Variable",
    "name": "direction",
    "variableName": "direction"
  },
  {
    "kind": "Variable",
    "name": "endDate",
    "variableName": "endDate"
  },
  {
    "kind": "Variable",
    "name": "matchKind",
    "variableName": "matchKind"
  },
  {
    "kind": "Variable",
    "name": "perspectiveId",
    "variableName": "perspectiveId"
  },
  {
    "kind": "Variable",
    "name": "regex",
    "variableName": "regex"
  },
  {
    "kind": "Variable",
    "name": "ruleId",
    "variableName": "ruleId"
  },
  {
    "kind": "Variable",
    "name": "startDate",
    "variableName": "startDate"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "capturedCount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "droppedCount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualConflictCount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "truncated",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Txn",
  "kind": "LinkedField",
  "name": "txn",
  "plural": false,
  "selections": [
    (v15/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postingDate",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNature",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = [
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/)
],
v23 = [
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v15/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "rulesPage_DeltaQuery",
    "selections": [
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "RuleDelta",
        "kind": "LinkedField",
        "name": "ruleDeltaPreview",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "captured",
            "plural": true,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "droppedRuleAssigned",
            "plural": true,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "droppedManual",
            "plural": true,
            "selections": (v22/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "rulesPage_DeltaQuery",
    "selections": [
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "RuleDelta",
        "kind": "LinkedField",
        "name": "ruleDeltaPreview",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "captured",
            "plural": true,
            "selections": (v23/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "droppedRuleAssigned",
            "plural": true,
            "selections": (v23/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "droppedManual",
            "plural": true,
            "selections": (v23/*: any*/),
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f87bf8978979843d7d8783cf40571f50",
    "id": null,
    "metadata": {},
    "name": "rulesPage_DeltaQuery",
    "operationKind": "query",
    "text": "query rulesPage_DeltaQuery(\n  $ruleId: ID!\n  $regex: String\n  $matchKind: String\n  $direction: String\n  $caseSensitive: Boolean\n  $startDate: ISO8601Date\n  $endDate: ISO8601Date\n  $accountIds: [ID!]\n  $delete: Boolean\n  $perspectiveId: ID\n) {\n  ruleDeltaPreview(ruleId: $ruleId, regex: $regex, matchKind: $matchKind, direction: $direction, caseSensitive: $caseSensitive, startDate: $startDate, endDate: $endDate, accountIds: $accountIds, delete: $delete, perspectiveId: $perspectiveId) {\n    capturedCount\n    droppedCount\n    manualConflictCount\n    truncated\n    captured {\n      txn {\n        id\n      }\n      postingDate\n      description\n      amount\n      accountNumber\n      expenseNature {\n        id\n        name\n      }\n      id\n    }\n    droppedRuleAssigned {\n      txn {\n        id\n      }\n      postingDate\n      description\n      amount\n      accountNumber\n      expenseNature {\n        id\n        name\n      }\n      id\n    }\n    droppedManual {\n      txn {\n        id\n      }\n      postingDate\n      description\n      amount\n      accountNumber\n      expenseNature {\n        id\n        name\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c2d8f72120a42ad91b2ead330dfa6f5c";

export default node;
